import { createAsyncThunk } from "@reduxjs/toolkit";
import brandSocialHandlesApi from "../api/brandSocialHandlesApi.tsx";
import {
  CompetitorCreateDataType,
  CompetitorEditDataType,
  FetchCompetitorByIdDataType,
  DeleteUsernameByIdDataType,
  UsernameCreateDataType,
  UsernameEditDataType,
  ValidateBodyType,
} from "../types/brandSocialHandlesTypes.tsx";
import { handleThunkError } from "./handleThunkError";

export const fetchSocialUsernames = createAsyncThunk(
  "brand/fetchSocialUsernames",
  async (id: number, thunkAPI) => {
    try {
      const response = await brandSocialHandlesApi.fetchSocialUsernames(id);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const createSocialUsernames = createAsyncThunk(
  "brand/createSocialUsernames",
  async (data: UsernameCreateDataType, thunkAPI) => {
    try {
      console.log("name", data.brandId);
      const response = await brandSocialHandlesApi.createSocialUsernames(data);
      if (data.callback) {
        data.callback();
      }
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const editSocialUsernamesById = createAsyncThunk(
  "brand/editSocialUsernamesById",
  async (data: UsernameEditDataType, thunkAPI) => {
    try {
      const response =
        await brandSocialHandlesApi.editSocialUsernamesById(data);
      if (data.callback) {
        data.callback();
      }
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const deleteSocialUsernamesById = createAsyncThunk(
  "brand/deleteSocialUsernamesById",
  async (data: DeleteUsernameByIdDataType, thunkAPI) => {
    try {
      const response =
        await brandSocialHandlesApi.deleteSocialUsernamesById(data);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const fetchCompetitors = createAsyncThunk(
  "brand/fetchCompetitors",
  async (id: number, thunkAPI) => {
    try {
      const response = await brandSocialHandlesApi.fetchCompetitors(id);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const createCompetitor = createAsyncThunk(
  "brand/createCompetitor",
  async (data: CompetitorCreateDataType, thunkAPI) => {
    try {
      const response = await brandSocialHandlesApi.createCompetitor(data);
      if (data.callback) {
        data.callback();
      }
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const editCompetitorById = createAsyncThunk(
  "brand/editCompetitorById",
  async (data: CompetitorEditDataType, thunkAPI) => {
    try {
      const response = await brandSocialHandlesApi.editCompetitorById(data);
      if (data.callback) {
        data.callback();
      }
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const deleteCompetitorById = createAsyncThunk(
  "brand/deleteCompetitorById",
  async (data: FetchCompetitorByIdDataType, thunkAPI) => {
    try {
      const response = await brandSocialHandlesApi.deleteCompetitorById(data);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);
export const fetchCreatorPartnerUsernames = createAsyncThunk(
  "brand/fetchCreatorPartnerUsernames",
  async (id: number, thunkAPI) => {
    try {
      const response =
        await brandSocialHandlesApi.fetchCreatorPartnerUsernames(id);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const createCreatorPartnerUsernames = createAsyncThunk(
  "brand/createCreatorPartnerUsernames",
  async (data: UsernameCreateDataType, thunkAPI) => {
    try {
      const response =
        await brandSocialHandlesApi.createCreatorPartnerUsernames(data);
      if (data.callback) {
        data.callback();
      }
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const editCreatorPartnerUsernamesById = createAsyncThunk(
  "brand/editCreatorPartnerUsernamesById",
  async (data: UsernameEditDataType, thunkAPI) => {
    try {
      const response =
        await brandSocialHandlesApi.editCreatorPartnerUsernamesById(data);
      if (data.callback) {
        data.callback();
      }
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const deleteCreatorPartnerUsernamesById = createAsyncThunk(
  "brand/deleteCreatorPartnerUsernamesById",
  async (data: DeleteUsernameByIdDataType, thunkAPI) => {
    try {
      const response =
        await brandSocialHandlesApi.deleteCreatorPartnerUsernamesById(data);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);

export const validateSocialHandle = createAsyncThunk(
  "brand/validateSocialHandle",
  async (data: ValidateBodyType, thunkAPI) => {
    try {
      const response = await brandSocialHandlesApi.validateSocialHandle(data);
      return response.data;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        handleThunkError(e, thunkAPI.dispatch, "An unexpected error occurred."),
      );
    }
  },
);
